export default __webpack_public_path__ + "src/assets/faucet.a235437db5271b1951df300977db8215.svg";